import { useMutation, useQueryClient } from '@tanstack/react-query';
import { schedulingApi } from '@/api';

const APPOINTMENTS_KEY = 'appointments';

export function useRescheduleAppointment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ appointmentId, newSlotId }: { appointmentId: string; newSlotId: string }) =>
      schedulingApi.rescheduleAppointment(appointmentId, newSlotId),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [APPOINTMENTS_KEY] });
      if (data.originalAppointment) {
        queryClient.setQueryData(
          [APPOINTMENTS_KEY, 'appointment', data.originalAppointment.id],
          (old: unknown) => ({
            ...(old as object),
            status: data.originalAppointment.status,
            scheduledAt: data.originalAppointment.scheduledAt,
          })
        );
      }
      if (data.newAppointment) {
        queryClient.setQueryData(
          [APPOINTMENTS_KEY, 'appointment', data.newAppointment.id],
          (old: unknown) => ({
            ...(old as object),
            status: data.newAppointment.status,
            scheduledAt: data.newAppointment.scheduledAt,
            slot: data.newAppointment.slot,
          })
        );
      }
    },
  });
}
